import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@helios/ui';
import { ConstructionOsLogo } from '@/components/brand/ConstructionOsLogo';
import { NavTree } from '@/components/navigation/NavTree';
import { useSidebarNavGroups } from '@/navigation/useSidebarNavGroups';
import { useUiStore } from '@/stores/uiStore';

/** Slide-in navigation drawer for tablet / mobile (Radix-backed focus trap). */
export function MobileNav() {
  const open = useUiStore((state) => state.mobileNavOpen);
  const setOpen = useUiStore((state) => state.setMobileNavOpen);
  const navGroups = useSidebarNavGroups();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="left" className="w-72 border-border/70 bg-card/[0.92] p-0 backdrop-blur-glass">
        <SheetHeader className="items-center justify-center border-b border-border/60 bg-background/35 px-4 py-4">
          <ConstructionOsLogo variant="mobile" />
          <SheetTitle className="sr-only">HELIOS Construction OS</SheetTitle>
          <SheetDescription className="sr-only">Primary navigation</SheetDescription>
        </SheetHeader>
        <nav aria-label="Modules" className="overflow-y-auto p-1.5">
          <NavTree groups={navGroups} onNavigate={() => setOpen(false)} />
        </nav>
      </SheetContent>
    </Sheet>
  );
}
